import React, { useEffect, useState } from 'react';
import { uri } from '../../../../utils/config';
import { HTTP } from '../../../../apis/secure/http';
import { defaultDates, defaultValues, defaultMap } from '../../../../utils/graph';
import moment from 'moment';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const options = {
  responsive: true,
  maintainAspectRatio: false,
  // borderWidth: 1,
  // pointRadius: 2,
  plugins: {
    legend: {
      position: 'top',
    },
  },
};

const defaultData = {
  labels: defaultDates,
  datasets: [
    {
      label: 'View Count',
      data: defaultValues,
      borderColor: 'rgb(255, 99, 132)',
      backgroundColor: 'rgba(25, 118, 210, 0.8)',
    },
  ],
};


export const ViewsCurrentYear = ({ placeId }) => {
  const [data, setData] = useState(defaultData);

  useEffect(() => {
    getCurrentYear();
  }, []);

  const getCurrentYear = async () => {
    let incomingGraph = null;
    try {
      const response = await HTTP.get({
        path: `${uri.api}/demographics/place/${placeId}`,
      });
      incomingGraph = response.data.views;
    } catch (error) {
      console.log('ERROR', error);
      incomingGraph = [];
      return;
    }

    if (!Array.isArray(incomingGraph)) {
      incomingGraph = [];
      return;
    }

    const views = [...defaultValues];
    const labels = [...defaultDates];
    for (const entry of incomingGraph) {
      const newDate = moment(entry.ts).format('MMM D');
      views[defaultMap[newDate]] = entry.views;
    }

    setData({
      labels,
      datasets: [
        {
          label: 'View Count',
          data: views,
          borderColor: 'rgb(255, 99, 132)',
          backgroundColor: 'rgba(25, 118, 210, 0.8)',
        },
      ],
    });
  };

  if (!data) {
    return null;
  }

  return <Bar options={options} data={data} />;
};
